import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap"

export class DecadenceWinCapPresentation extends SimplePresentation {


    constructor() {
        super("WincapPresentation", false);
    }

    shouldRun(): boolean {
        return Decadence.model.brokeTheBank;
    }

    buildTimeline() {
        const tl = this.tl;
        tl.eventCallback("onComplete", () => {});
        // Padding before wincap
        tl.add(() => {}, ">0.5");

        tl.add(() => {
            this.controller.setSkipCallback(() => {
                Decadence.soundPlayer.playSound("capwinCountupAbort");
                tl.seek("skip", false);
            })
        });

        tl.add(Decadence.transitionScreen.darken(0.2));
        tl.add(() => {
            Decadence.keypadPlugin.setZeroBetSpinCounter(-1);
            Decadence.soundPlayer.fadeOutMusic();
            Decadence.soundPlayer.playSound("capwinCountup");
        }, "<")
        tl.add(Decadence.transitionScreen.showWinCap());

        tl.add(Decadence.winCounter.countUpWincap(0, Decadence.model.accumulatedWin, 5, 0x00ff00));
        tl.add(() => {
            Decadence.soundPlayer.stopSound("capwinCountup");
            Decadence.soundPlayer.fadeInMusic();
            Decadence.soundPlayer.switchMusic("WINCAP");
            const isTotalWin = Decadence.model.mode != GameMode.NORMAL || Decadence.model.nextMode != GameMode.NORMAL;
            Decadence.keypadPlugin.setWin(Decadence.model.accumulatedWin, isTotalWin, Decadence.model.winBelowStake);
        })
        tl.addLabel("skip");
        tl.add(() => {
            this.controller.setSkipCallback(undefined);
        })
        tl.add(Decadence.transitionScreen.enableButton(() => this.onButtonPressed()));
    }

    private onButtonPressed():void {
        if(Decadence.model.isFreeSpins) {
            Decadence.reelView.playMonsterFallAsleep()
            Decadence.backgroundElements.transitionMode(GameMode.NORMAL);
        }
        Decadence.soundPlayer.playSound("capwinEnds");
        Decadence.soundPlayer.switchMusic(GameMode.NORMAL);
        Decadence.soundPlayer.fadeInMusic();
        //Decadence.keypadPlugin.show();
        Decadence.transitionScreen.hide();
        Decadence.winCounter.hide();

        // Make sure all animations finish
        gsap.timeline().add(() => {
            this.controller.finish();
        }, ">1")
    }
}